import PageHeader from "../components/PageHeader";
import Contact from "../components/Contact";

function ContactPage() {
  return (
    <>
      <PageHeader
        crumb="Contact"
        eyebrow="Get In Touch"
        title="Contact Us"
        lead="Tell us about your project and our team will get back to you within one business day."
      />
      <Contact />
    </>
  );
}

export default ContactPage;
